import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { ConfigModule } from 'NewAngular/config/config.module';
import { SingleSelectDropdownModule } from 'NewAngular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import { ModuleUpsellModule } from 'SecuritiesApp/ts/features/module-upsell/module-upsell.module';
import * as i0 from "@angular/core";
export class HoldingsCategoriesTableModule {
}
HoldingsCategoriesTableModule.ɵfac = function HoldingsCategoriesTableModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HoldingsCategoriesTableModule)(); };
HoldingsCategoriesTableModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: HoldingsCategoriesTableModule });
HoldingsCategoriesTableModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        ConfigModule,
        FeatureNeededModule,
        HttpClientModule,
        IconModule,
        ModuleUpsellModule,
        SingleSelectDropdownModule,
        TooltipModule] });
